import React, { useState, useEffect } from "react";
import { RiCloseLine } from "react-icons/ri";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Puff } from "react-loader-spinner";
import { IoDocumentAttach } from "react-icons/io5";
import { EditClientPRO } from "UpdatedFeatures/api";
import cities from "../POS/cities.json";
import countries from "../POS/countries.json";

const UpdateClientModal = ({ open, onClose, client, onUpdate }) => {
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    company_name: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country: "",
    city: "",
    adress: "",
    zip_code: "",
    registration_document: null,
  });
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  // const countryStates = cities.filter(
  //   (city) => city.stateId === String(selectedCountry)
  // );

  console.log(client);
  console.log(formData);

  useEffect(() => {
    if (client) {
      setFormData({ ...client, registration_document: null });

      if (client?.registration_document) {
        const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
        setPreviewUrl(`${BASE_URL}storage/${client.registration_document}`);
      }

      // Set selected country
      const countryId = countries.find((c) => c.name_fr === client.country)?.id;
      setSelectedCountry(countryId);

      if (countryId) {
        const states = cities.filter((c) => c.stateId === String(countryId));
        const selectedCity = states.find(
          (c) => c.name_fr === client.city
        )?.name_fr;
        setSelectedState(selectedCity);
      }
    }
  }, [client]);

  function convertUnicodeToEmoji(unicode) {
    return unicode
      .split(" ")
      .map((u) => String.fromCodePoint(parseInt(u.replace("U+", ""), 16)))
      .join("");
  }
  const updateMutation = useMutation({
    mutationFn: (formDataToSend) => EditClientPRO(client.id, formDataToSend),
    onSuccess: () => {
      toast.success("Client mis à jour avec succès");
      queryClient.invalidateQueries(["clients-pro"]);
      onUpdate();
    },
    onError: (err) => {
      console.log(err);
      toast.error(
        err.response?.data?.message || "Erreur lors de la mise à jour"
      );
    },
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, registration_document: file }));
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateMutation.mutate(formData);
  };

  const sortedCountries = [...countries].sort((a, b) =>
    a.name_fr.localeCompare(b.name_fr)
  );

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    const selectedCountry = countries.find(
      (country) => country.id === Number(e.target.value)
    );
    setFormData((prev) => ({ ...prev, country: selectedCountry?.name_fr }));
    setSelectedState("");
    setFormData((prev) => ({ ...prev, city: "" }));
  };
  const handleCityChange = (e) => {
    setSelectedState(e.target.value);
    setFormData((prev) => ({ ...prev, city: e.target.value }));
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 overflow-auto"
      style={{ zIndex: 9991 }}
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="relative w-full max-w-3xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex justify-between items-center p-6 bg-[#b269ae] text-white border-b border-gray-500/30">
            <h3 className="text-lg font-medium">
              Modifier les informations du client
            </h3>
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 hover:text-gray-200"
            >
              <RiCloseLine className="h-6 w-6" />
            </button>
          </div>

          {/* Form */}
          <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Client Information */}
              <div className="bg-gray-50 border p-4 rounded-lg">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[
                    {
                      label: "Raison sociale",
                      name: "company_name",
                      type: "text",
                    },
                    {
                      label: "Prénom du dirigeant",
                      name: "first_name",
                      type: "text",
                    },
                    {
                      label: "Nom du dirigeant",
                      name: "last_name",
                      type: "text",
                    },
                    { label: "Adresse mail", name: "email", type: "email" },
                    { label: "Téléphone", name: "phone", type: "tel" },
                    { label: "Pays", name: "country", type: "text" },
                    { label: "Ville", name: "city", type: "text" },
                    { label: "Adresse", name: "adress", type: "text" },
                    {
                      label: "Code Postal / ZIP",
                      name: "zip_code",
                      type: "text",
                    },
                  ].map(({ label, name, type }) =>
                    label == "Pays" ? (
                      <div>
                        <label
                          htmlFor="country"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Pays
                        </label>
                        <select
                          id="country"
                          name="country"
                          value={selectedCountry}
                          onChange={handleCountryChange}
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#b269ae] focus:ring-[#b269ae] sm:text-sm"
                        >
                          <option value="">Sélectionner un pays</option>
                          {sortedCountries.map((country) => (
                            <option key={country.id} value={country.id}>
                              {convertUnicodeToEmoji(country.emojiU)}{" "}
                              {country.name_fr}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : label == "Ville" ? (
                      <div>
                        <label
                          htmlFor="city"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Ville
                        </label>
                        <input
                          id="city"
                          name="city"
                          type="text"
                          value={formData.city}
                          onChange={handleInputChange}
                          placeholder="Ville"
                          className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 h-12"
                        />
                      </div>
                    ) : (
                      <div key={name}>
                        <label className="block text-sm font-medium text-gray-700">
                          {label}
                        </label>
                        <input
                          type={type}
                          name={name}
                          value={formData[name]}
                          onChange={handleInputChange}
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#b269ae] focus:ring-[#b269ae] sm:text-sm"
                          required
                        />
                      </div>
                    )
                  )}
                </div>
              </div>

              {/* Document Upload */}
              <div className="bg-gray-50 border p-4 rounded-lg">
                <h4 className="text-md font-semibold text-gray-800 pb-2 border-b">
                  Document d'immatriculation
                </h4>
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Nouveau document (optionnel)
                  </label>
                  <input
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf,.jpg,.jpeg,.png"
                    className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#b269ae] file:text-white hover:file:bg-[#9c58a3]"
                  />
                </div>
                {previewUrl && (
                  <a
                    href={previewUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 flex justify-center items-center gap-2 bg-yellow-400 text-white p-2 rounded-full"
                  >
                    <IoDocumentAttach size={20} />
                    Voir le document actuel
                  </a>
                )}
              </div>

              {/* Form Actions */}
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={updateMutation.isLoading}
                  className="px-4 py-2 text-sm font-medium text-white bg-[#b269ae] rounded-md hover:bg-[#9c58a3] disabled:opacity-50"
                >
                  {updateMutation.isLoading ? (
                    <div className="flex items-center">
                      <Puff
                        color="white"
                        height={16}
                        width={16}
                        className="mr-2"
                      />
                      Enregistrement...
                    </div>
                  ) : (
                    "Enregistrer les modifications"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateClientModal;
